import sanityClient from "@sanity/client";
import imageUrlBuilder from "@sanity/image-url";

export const client = sanityClient({
  projectId: "06yd5fkd",
  dataset: "production",
  apiVersion: "2022-02-01",
  useCdn: true,
  token:
    "skSu9ouEZL8R0nE02KNodydrDEE1EcS0VLMkZh35XU1S17sVxYLBakvURtSgGHRjp38cxUs3P0kNm3tPdQf3F1jVrJJKicntludCwBIZgxKiYOfVImq4pVNnKgs6xOLP68ovHWnRo8gZDqsAspG0l26qoPMIY6EOjo4HkNzMYZNKFoyvpP0h",
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);
